import { 
  faDatabase,
  faNoteSticky,
  faFilm
 } from '@fortawesome/free-solid-svg-icons'

// Импорт иконок
import groups_icon from '../../../img/groups.svg';
import documents_icon from '../../../img/documents.svg';
import staff_icon from '../../../img/staff.svg';
import base_icon from '../../../img/base.svg';
import passport_icon from '../../../img/passport.svg';
import zvit_icon from '../../../img/zvit.svg';
import parents_icon from '../../../img/parents.svg';
import orders_icon from '../../../img/orders.svg';
import statistic_icon from '../../../img/statistic.svg';
import location_icon from '../../../img/location.svg';
import collection_icon from '../../../img/collection-fill.svg';
import personalcab_icon from '../../../img/person-hearts.svg';
import instruct_icon from '../../../img/book-solid-full.svg';
import media from '../../../img/photo-film-solid.svg'

import diagram_3_icon from '../../../img/diagram-3-fill.svg';
import { icon } from 'leaflet';


  const title = 'Додати групу';

  const   rightPossible = {
    isPossibleAddGroup: true,
    dictionaryEdit:{
      docs: false,
      positions: false,
      years: false
    },
    isPossibleEditGroup: true
  }

 
  const menuItems = [
    {
      id: 'groups',
      label: 'Групи',
      icon: groups_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    },
    {
      id: 'childrens',
      label: 'Діти',
      icon: documents_icon,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'documents',
      label: 'Документи',
      icon: documents_icon,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'newseditor',
      label: 'Новини',
      icon: documents_icon,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'staff',
      label: 'Працівники',
      icon: staff_icon,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'staff_schedule',
      label: 'штатний розпис',
      icon: diagram_3_icon,
      hasDropdown: false,
      href: '#',
      badge: null
    },{
      id: 'media',
      label: 'Галерея садочка',
      icon: media,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'base',
      label: 'Матеріально-технічна база',
      icon: base_icon,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'passport',
      label: 'Паспорт ЗДО',
      icon: passport_icon,
      hasDropdown: false,
      href: 'cabinet-passport.html',
      badge: null
    },
    {
      id: 'zvit',
      label: 'Звітність',
      icon: zvit_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    },
    {
      id: 'parents',
      label: 'Прийом батьків',
      icon: parents_icon,
      hasDropdown: true,
      href: 'cabinet-parents.html',
      badge: null
    },
    {
      id: 'orders',
      label: 'Заявки',
      icon: orders_icon,
      hasDropdown: false,
      href: '#',
      badge: 12
    },
    {
      id: 'dictionary',
      label: 'Довідники',
      icon: collection_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    }
  ];

  const level2Items = {
    
    "groups":[
        {
            id: 'groups_actual',
            label: 'Актуальні',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'groups_archive',
            label: 'Архів',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        }
    ],
    "dictionary":[
           {
            id: 'dict_docs',
            label: 'Типи документів',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'dict_tarifs',
            label: 'Тарифи харчування',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'proffessions',
            label: 'Найменування посад',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'years_dict',
            label: 'Навчальний  рік',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },{
            id: 'dict_places',
            label: 'Типи місць',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        }

    ],
    "base":[
        {
            id: 'base_bda',
            label: 'Приміщення',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'base_pc',
            label: 'Компьютери',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        },
        {
            id: 'vacancy',
            label: 'Вакансії',
            icon: groups_icon,
            hasDropdown: true,
            href: '#',
            badge: null
        }
    ],
    "parents":[
      {
      id: 'parents_list',
      label: 'Записані на прийом',
      icon: parents_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    },{
      id: 'parents_schedule',
      label: 'Розклад прийому',
      icon: parents_icon,
      hasDropdown: true,
      href: '#',
      badge: null
    },
    ],
    "staff":[
      {
        id: 'staff',
        label: "Працівники"
      },
//      {
//        id: 'users',
//        label: "Доступ"
//      },
      {
        id: 'teamadmin',
        label: "Команда"
      }
    ],
    "zvit":[
      {id: 'zvit', label: 'Загальна'},
      { id: 'k85', label: 'Звіт 85-К'}
    ]
  }

  const additionalLinks = [
   {
      id: 'all-kindergartens',
      label: 'Всі садочки',
      icon: location_icon,
      href: '/kglist'
    },
    {
      id: 'statistics',
      label: 'Статистика публічна',
      icon: statistic_icon,
      href: '/publicstatistics'
    },
    {
      id: 'statistics',
      label: 'Мій кабінет батьків',
      icon: personalcab_icon,
      href: '/cabinet',
      active: false
    },
    {
      id: 'statistics',
      label: 'Інструкція користувача',
      icon: instruct_icon,
      href: '/instructions',
      active: true,
      download: {url: 'instruction_file', name: 'Instruction.pdf'}
    }
  ];

  const cabinetName = "Кабінет керівника ЗДО";

  const Menu = { menuItems, level2Items, additionalLinks, title, cabinetName, rightPossible };

  export {menuItems, level2Items, additionalLinks, title, rightPossible};

  export default Menu;